export default __webpack_public_path__ + "static/usa_georgia_jumbo_bucks-1c89a2dc4c18a7dc6c197a29406ab267.png";